import React from 'react';
import './Cali.css'; 

const Bogota = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
      <h1><a className='Titulo' href="/aip/SKBO.pdf" target="_blank" rel="noreferrer">Aeropuerto Internacional El Dorado</a></h1>
    </div>

    {/* PISTA NORTE */}
    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 14L</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">TOBK4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">TOBK1S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">OSUS4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DANS4R.pdf" target="_blank" rel="noreferrer">DANS4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DANS4R.pdf" target="_blank" rel="noreferrer">VASI4U</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ISNO2S.pdf" target="_blank" rel="noreferrer">ISNO2S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ISNO2S.pdf" target="_blank" rel="noreferrer">LIXA4U</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ISNO2S.pdf" target="_blank" rel="noreferrer">POVS5U</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ISNO2S.pdf" target="_blank" rel="noreferrer">SILE5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ISNO2S.pdf" target="_blank" rel="noreferrer">VAPO4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/USID4B.pdf" target="_blank" rel="noreferrer">USID4B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3A.pdf" target="_blank" rel="noreferrer">ABL3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3A.pdf" target="_blank" rel="noreferrer">KAMI6A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3A.pdf" target="_blank" rel="noreferrer">SILE2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3A.pdf" target="_blank" rel="noreferrer">BOGU8A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL7E.pdf" target="_blank" rel="noreferrer">ABL7E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/EVRA5B.pdf" target="_blank" rel="noreferrer">EVRA5B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/EVRA5B.pdf" target="_blank" rel="noreferrer">ZIP5H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ZIP3C.pdf" target="_blank" rel="noreferrer">ZIP3C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/UGRO1A.pdf" target="_blank" rel="noreferrer">UGRO1A</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 32R</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">TOBK4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">TOBK1S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">OSUS4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DANS4R.pdf" target="_blank" rel="noreferrer">DANS4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DANS4R.pdf" target="_blank" rel="noreferrer">VASI2T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/LIXA2T.pdf" target="_blank" rel="noreferrer">ISNO2S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/LIXA2T.pdf" target="_blank" rel="noreferrer">LIXA2T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/LIXA2T.pdf" target="_blank" rel="noreferrer">POVS3T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/LIXA2T.pdf" target="_blank" rel="noreferrer">SILE1F</a></th>
          </tr>          
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/LIXA2T.pdf" target="_blank" rel="noreferrer">VAPO4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/USID3C.pdf" target="_blank" rel="noreferrer">USID3C</a></th>
          </tr>          
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/USID4A.pdf" target="_blank" rel="noreferrer">USID4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/USID4A.pdf" target="_blank" rel="noreferrer">ZIP4B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL4K.pdf" target="_blank" rel="noreferrer">ABL4K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL4K.pdf" target="_blank" rel="noreferrer">ZIP4D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/BOGU4C.pdf" target="_blank" rel="noreferrer">BOGU4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/BOGU4C.pdf" target="_blank" rel="noreferrer">KAMI4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/BOGU4C.pdf" target="_blank" rel="noreferrer">SILE4D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/SOA1A.pdf" target="_blank" rel="noreferrer">SOA1A</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 14L</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">DOPL5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">EGEP5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">EGEP3T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">ENVA5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">ILSE5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">SIRU5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">VUNE5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">VUNE3T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">ATAN5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">EDPU5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">ISVA5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">TIRT5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">TOLI5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">GIR5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">ATAN5T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">GRUD5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">GRUD5T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">MUGO5T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3L.pdf" target="_blank" rel="noreferrer">ABL3L</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3L.pdf" target="_blank" rel="noreferrer">VULA7D</a></th>
          </tr>
           
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 32R</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">DOPL5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">EGEP4S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">EGEP3R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">EGEP5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">ENVA5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">ILSE5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">SIRU3S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">SIRU5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">VUNE3R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">VUNE5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">ATAN5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">EDPU5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">ISVA5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">TIRT5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">TOLI5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">GIR5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">ATAN5S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">GRUD5S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">GRUD5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">MUGO5S</a></th>
          </tr>
           <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3M.pdf" target="_blank" rel="noreferrer">ABL3M</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3M.pdf" target="_blank" rel="noreferrer">VULA4F</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 14L</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ILSX14L.pdf" target="_blank" rel="noreferrer">ILS X</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ILSY14L.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ILSZ14L.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNP14L.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ILSZ14L.pdf" target="_blank" rel="noreferrer">LOC Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/VOR14L.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>          

          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 32R</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNPC32R.pdf" target="_blank" rel="noreferrer">RNP C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNPD32R.pdf" target="_blank" rel="noreferrer">RNP D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNPW32R.pdf" target="_blank" rel="noreferrer">RNP W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNPY32R.pdf" target="_blank" rel="noreferrer">RNP Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNPZ32R.pdf" target="_blank" rel="noreferrer">RNP Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/VORA32.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
          </table>
        </div>
      </div>

    </div>
    {/* PISTA SUR */}
    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 14R</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">TOBK4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">TOBK1S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">OSUS4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DANS4R.pdf" target="_blank" rel="noreferrer">DANS4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DANS4R.pdf" target="_blank" rel="noreferrer">VASI4U</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ISNO2S.pdf" target="_blank" rel="noreferrer">ISNO2S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ISNO2S.pdf" target="_blank" rel="noreferrer">LIXA4U</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ISNO2S.pdf" target="_blank" rel="noreferrer">POVS5U</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ISNO2S.pdf" target="_blank" rel="noreferrer">SILE5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ISNO2S.pdf" target="_blank" rel="noreferrer">VAPO4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/USID4B.pdf" target="_blank" rel="noreferrer">USID4B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3A.pdf" target="_blank" rel="noreferrer">ABL3A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3A.pdf" target="_blank" rel="noreferrer">KAMI6A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3A.pdf" target="_blank" rel="noreferrer">SILE2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3A.pdf" target="_blank" rel="noreferrer">BOGU8A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL7E.pdf" target="_blank" rel="noreferrer">ABL7E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/EVRA5B.pdf" target="_blank" rel="noreferrer">EVRA5B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/EVRA5B.pdf" target="_blank" rel="noreferrer">ZIP5H</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ZIP3C.pdf" target="_blank" rel="noreferrer">ZIP3C</a></th>
          </tr>

          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 32L</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">TOBK4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">TOBK1S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/TOBK4R.pdf" target="_blank" rel="noreferrer">OSUS4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DANS4R.pdf" target="_blank" rel="noreferrer">DANS4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DANS4R.pdf" target="_blank" rel="noreferrer">VASI2T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/LIXA2T.pdf" target="_blank" rel="noreferrer">ISNO2S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/LIXA2T.pdf" target="_blank" rel="noreferrer">LIXA2T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/LIXA2T.pdf" target="_blank" rel="noreferrer">POVS3T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/LIXA2T.pdf" target="_blank" rel="noreferrer">SILE1F</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/LIXA2T.pdf" target="_blank" rel="noreferrer">VAPO4R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/USID3C.pdf" target="_blank" rel="noreferrer">USID3C</a></th>
          </tr>          
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/USID4A.pdf" target="_blank" rel="noreferrer">USID4A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/USID4A.pdf" target="_blank" rel="noreferrer">ZIP4B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL4K.pdf" target="_blank" rel="noreferrer">ABL4K</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL4K.pdf" target="_blank" rel="noreferrer">ZIP4D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/BOGU4C.pdf" target="_blank" rel="noreferrer">BOGU4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/BOGU4C.pdf" target="_blank" rel="noreferrer">KAMI4C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/BOGU4C.pdf" target="_blank" rel="noreferrer">SILE4D</a></th>
          </tr>
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 14R</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">DOPL5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">EGEP5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">EGEP3T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">ENVA5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">ILSE5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">SIRU5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">VUNE5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">ATAN5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">EDPU5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">ISVA5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">TIRT5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">TOLI5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">GIR5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">ATAN5T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">GRUD5E</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">GRUD5T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">MUGO5T</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3L.pdf" target="_blank" rel="noreferrer">ABL3L</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3L.pdf" target="_blank" rel="noreferrer">VULA7D</a></th>
          </tr>
          </table>

          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 32L</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">DOPL5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">EGEP4S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">EGEP3R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">EGEP5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">ENVA5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">ILSE5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">SIRU3S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">SIRU5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">VUNE3R</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/DOPLO5E.pdf" target="_blank" rel="noreferrer">VUNE5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">ATAN5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">EDPU5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">ISVA5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">TIRT5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">TOLI5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5E.pdf" target="_blank" rel="noreferrer">GIR5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">ATAN5S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">GRUD5S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">GRUD5W</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ATAN5T.pdf" target="_blank" rel="noreferrer">MUGO5S</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3M.pdf" target="_blank" rel="noreferrer">ABL3M</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ABL3M.pdf" target="_blank" rel="noreferrer">VULA4F</a></th>
          </tr>

          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 14R</th>                      
          </tr>          
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ILSX14R.pdf" target="_blank" rel="noreferrer">ILS X</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ILSY14R.pdf" target="_blank" rel="noreferrer">ILS Y</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ILSZ14R.pdf" target="_blank" rel="noreferrer">ILS Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNP14R.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/ILSZ14R.pdf" target="_blank" rel="noreferrer">LOC Z</a></th>
          </tr>         
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/VOR14R.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>

          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 32L</th>                      
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNPC32L.pdf" target="_blank" rel="noreferrer">RNP C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNPC32L.pdf" target="_blank" rel="noreferrer">RNP D</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNPW32L.pdf" target="_blank" rel="noreferrer">RNP W</a></th>
          </tr> 
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNPY32L.pdf" target="_blank" rel="noreferrer">RNP Y</a></th>
          </tr>                  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/RNPZ32L.pdf" target="_blank" rel="noreferrer">RNP Z</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKBO/VORA32.pdf" target="_blank" rel="noreferrer">VOR A</a></th>
          </tr>
         
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Bogota;